import { get } from "lodash";
import { useRecordContext } from "react-admin";
import { showRecurringRules } from "~/helpers/showDate";

export const RRuleField = (props) => {
  const record = useRecordContext(props);
  const value = get(record, props.source);
  return showRecurringRules(value);
};
